import { millisecondsInHour, millisecondsInSecond, millisecondsInMinute } from 'date-fns';
import { StringUtils } from '../StringUtils/StringUtils';
export class DurationUtils {
  private constructor() {}
  public static formatDurationToHourMinuteSecondString(durationMs: number): string {
    const {
      hours,
      minutes,
      seconds
    } = this.getDurationParts(durationMs);
    return this.formatDurationParts(hours, minutes, seconds);
  }
  public static formatDurationToHourMinuteString(durationMs: number): string {
    const {
      hours,
      minutes
    } = this.getDurationParts(durationMs);
    return this.formatDurationParts(hours, minutes);
  }
  public static hoursToMilliseconds(hours: number): number {
    return hours * millisecondsInHour;
  }
  public static minutesToMilliseconds(minutes: number): number {
    return minutes * millisecondsInMinute;
  }
  public static secondsToMilliseconds(seconds: number): number {
    return seconds * millisecondsInSecond;
  }
  private static formatDurationParts(...parts: Array<number>): string {
    return parts.map(part => StringUtils.padLeft(part.toString(), 2)).join(':');
  }
  private static getDurationParts(durationMs: number): {
    hours: number;
    minutes: number;
    seconds: number;
  } {
    let remainingDuration = durationMs;
    const hours = Math.floor(remainingDuration / millisecondsInHour);
    remainingDuration -= hours * millisecondsInHour;
    const minutes = Math.floor(remainingDuration / millisecondsInMinute);
    remainingDuration -= minutes * millisecondsInMinute;
    const seconds = Math.floor(remainingDuration / millisecondsInSecond);
    return {
      hours,
      minutes,
      seconds
    };
  }
}